import React, { useState, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
// import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import clsx from 'clsx';
import { getFormData, getFieldErrors } from '../../lib/utils';
import Loading from '../atoms/Loading';
import Button from '../atoms/Button';
import styles from '../../styles/components/organisms/EditForm.module.scss';

interface EditFormProps {
  id: string;
  error?: any;
  loading?: boolean;
  children?: any;
  title?: string;
  submitLabel?: string;
  deletable?: boolean;
  deleteOnly?: boolean;
  checkOnce?: boolean;
  doubleBtns?: boolean;
  blocked?: boolean;
  noCols?: boolean;
  float?: boolean;
  className?: string;
  onCancel?: () => void;
  onFieldError?: (errors: string[]) => void;
  onSubmit: (data: any, deleteMode?: boolean) => void;
}

const EditForm = (props: EditFormProps) => {
  const { t } = useTranslation(['common']);
  const [formError, setFormError] = useState() as any;
  const [fieldErrors, setFieldErrors] = useState([]) as any;
  const [deleteMode, setDeleteMode] = useState(false);
  const {
    id,
    title,
    children,
    error,
    loading,
    deletable,
    deleteOnly,
    submitLabel,
    doubleBtns,
    noCols,
    float,
    className,
    onFieldError,
    blocked,
    checkOnce,
    onSubmit,
    onCancel,
  } = props;
  const classes = clsx(
    styles.editForm,
    { [styles.loading]: loading },
    { [styles.float]: float },
    { [styles.error]: !!formError || !!fieldErrors.length },
    { [styles.disabled]: loading || !!fieldErrors.length },
    { [styles.blocked]: blocked },
    { [styles.confirm]: deleteMode },
    className
  );

  /**
   * Handle form input
   */
  const validFields = (get?: boolean) => {
    setFormError('');
    const fieldErrors = getFieldErrors(id);
    // console.log(fieldErrors);
    setFieldErrors(fieldErrors);
    if (!!fieldErrors.length) {
      setFormError(t('common:form-input-error'));
    }
    if (!!onFieldError) {
      onFieldError(fieldErrors);
    }
    if (get) {
      return !!!fieldErrors.length;
    }
  };

  /**
   * Handle form submit
   */
  const submit = () => {
    if (!deleteMode && !validFields(true)) {
      console.log(id, 'fieldErrors', fieldErrors);
      return;
    }
    const formData = getFormData(id);
    console.log(id, 'submit', formData);
    setFormError('');
    onSubmit(formData, deleteMode);
    setDeleteMode(false);
  };

  useEffect(() => {
    // console.log('setFormError', error);
    setFormError(error);
  }, [error]);

  useEffect(() => {
    setFormError();
    setDeleteMode(false);
  }, [id]);

  // useEffect(() => {
  //   if(!!error){
  //     const { code, message } = error;
  //     const errorMsg = typeof error === "string"
  //       ? error
  //       : code
  //         ? code.split("/")[1]
  //         : message || true;
  //     const errorStr = `${t('common:form-error')} (${errorMsg})`;
  //     setFormError(errorStr);
  //   }
  // }, [error, t]);

  const editButtons = (
    <>
      {deleteMode && (
        <p>
          <small className={styles.alert}>
            {t('common:confirm-delete', { title })}
          </small>
        </p>
      )}
      {formError && (
        <p>
          <small className={styles.alert}>{formError}</small>
        </p>
      )}

      {(!deleteOnly || deleteMode) && (
        <Button
          small
          dark
          icon="check"
          label={
            deleteMode
              ? t('common:cta-confirm-delete')
              : submitLabel || t('common:cta-apply')
          }
          onClick={() => submit()}
        />
      )}

      {(deleteMode || !!onCancel) && (
        <Button
          small
          white
          icon="cancel"
          label={t('common:cta-cancel')}
          onClick={() => {
            deleteMode
              ? setDeleteMode(false)
              : !!onCancel
              ? onCancel()
              : undefined;
          }}
        />
      )}

      {deletable && !deleteMode && (
        <Button
          small
          red
          icon="delete"
          label={t('common:cta-delete')}
          onClick={() => setDeleteMode(true)}
        />
      )}
      <br />
      <br />
    </>
  );

  const buttons = !noCols ? (
    <Col xs={8}>{editButtons}</Col>
  ) : (
    <div className={styles.buttons}>{editButtons}</div>
  );

  return (
    <>
      <form
        id={id}
        className={classes}
        onChange={() => {
          if (checkOnce && !formError) return;
          validFields();
        }}
        // onMouseUp={() => {
        //   console.log("input");
        //   validFields();
        // }}
      >
        {!!title && !noCols ? (
          <Col xs={8}>
            <h2>{title}</h2>
          </Col>
        ) : (
          !!title && <h2>{title}</h2>
        )}
        {doubleBtns && buttons}
        {children}
        {buttons}
      </form>

      {loading && <Loading overlay />}
    </>
  );

  {
    /* <>
    <form id={id} className={classes} onChange={() => validFields()}>
      <Container>
        <Row>
          {!!title && 
            <Col xs={8}>
              <h2>{title}</h2>
            </Col>
          }
          {doubleBtns && buttons}
          {children}
          {buttons}
        </Row>
      </Container>
      {loading &&
        <Loading overlay/>
      }
      </form>
    </>; */
  }
};

export default EditForm;
